import { computed } from "vue";
import { useStore } from "vuex";

import { columns, options } from "@/helpers/rangeSectionsTableHelper";

export default function useRangeSectionsTable() {
  const store = useStore();

  const tableData = computed(() => store.getters["utilities/getRangeSections"]);

  const tableOptions = {
    ...options,
  };

  return {
    columns,
    tableData,
    tableOptions,
  };
}
